import { COLORS, FONTS, SIZE } from '@app/src/ui';
import styled from 'styled-components';

const ROOT = 'Home/listProducts/FindUs';

export const Wrapper = styled.div`
  padding: 65px 0;
  border-bottom: 1px solid #F0F0F0;
`;

Wrapper.className = `${ROOT}/Wrapper`;

export const Container = styled.div`
  max-width: 1200px;
  padding: 0 15px;
  margin: 0 auto;
  text-align: center;

  @media (min-width: ${SIZE.LARGE_DESKTOP}) {
    padding: 0;
  }
`;

Container.className = `${ROOT}/Container`;

export const Box = styled.a`
  border: 2px solid #D9CFFF;
  padding: 50px;
  margin: 0 auto;
  border-radius: 10px;
  display: inline-block;
`;

Box.className = `${ROOT}/Box`;

export const IconMapWrapper = styled.div`
  background: #D9CFFF;
  border-radius: 100%;
  width: 160px;
  height: 160px;
  margin-bottom: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

IconMapWrapper.className = `${ROOT}/IconMapWrapper`;

export const Title = styled.h3`
  color: ${COLORS.BLACK};
  font-family: ${FONTS.MONTSERRAT_BOLD};
  margin-bottom: 16px;
  font-size: 14px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 16px;
  }
`;

Title.className = `${ROOT}/Title`;

export const Text = styled.p`
  color: ${COLORS.GRAY_DARK};
  font-family: ${FONTS.ROBOTO};
  font-size: 14px;
  line-height: 24px;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 18px;
  }
`;

Text.className = `${ROOT}/Text`;

export const Content = styled.div`
  max-width: 320px;
`;

Content.className = `${ROOT}/Content`;